import Loadable from '@townsquare/loadable';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { rovoSearchRoute } from '@townsquare/routes/rovo-search-view';
import { rovoEntitlementResource } from '@townsquare/rovo/entitlement';

const RovoViewLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "rovo-search-view" */ './components/RovoSearchView'),
	loading: () => null,
});

rovoSearchRoute.component = RovoViewLoadable;
rovoSearchRoute.resources = [rovoEntitlementResource];

export const rovoSearchRouterRoute: GlobalHomePageRoute = rovoSearchRoute;
